import angular from "angular";
import Vue from "vue";
import "ngVue";

import Changelog from "./Changelog.vue";

export default angular
  .module("directives.changelog", [])
  .directive("dcChangelog", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcChangelog", Changelog));
    },
  ]);
